import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";

export function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      // id={`simple-tabpanel-${index}`}
      // aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {value === index && <Box sx={{ p: 1, margin: 0, padding: 0 }}>{children}</Box>}
    </div>
  );
}

export function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any,
  value: PropTypes.any,
};

export function PersonFullName({ person, ...rest }) {
  return (
    <Typography {...rest}>
      {person?.personFirstName} {person?.personLastName}
    </Typography>
  );
}
PersonFullName.propTypes = {
  person: PropTypes.object,
};
